const langtrans={
      bxgsjy:["保险公司救援服务","Insurance Company Assistance Service"],
      wmllnz:["无论你在哪里，有求必救！","Wherever you are, your request will get responded!"],
      ddjxjy:["大救星救援云全球服务能力","The global service capacity of the Big Suvior Assistance Cloud"],
      ttggzh:["，通过整合全球相关资源，线上和线下结合，为保险公司的出入境客户提供及时、高效的救援救助服务","Based on the Mobile Internet Technology and LBS, the Great Savior can offer the entry and exit customers of the insurance company timely and efficienct Assistance service via integrating the related global resource and combining online and off-line platforms."],
      qjdyxc:["求救第一现场","seeking help at the first scene"],
      jyjjdd:["救援节点监管","Surveillance of Assistance Nodes"],
      jyjg:["救援机构","Assistance agency"],
      fggqqz:["覆盖全球26种行业","covering wordly 26 kinds of industries"],
      jzxss:["救助星使","Assistance Xingshi"],
      bpbqqg:["遍布全球540个城市","Around 540 cities in the world"],
      jlhgzz:["建立合作","To establish cooperation"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/insurer.vue.trans.js